import type { IProjectRiskFormValues } from "@/containers/RisksAndIssues/interfaces/IProjectRisk";
import {
  appendQueryParameters,
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const projectRisksApi = createApi({
  reducerPath: "projectRisksApi",
  baseQuery: fetchBaseQueryWrapper(),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getProjectRisks: build.query({
      query: ({ publicProjectId, queryParameters }) =>
        appendQueryParameters(`projects/${publicProjectId}/risks`, queryParameters),
    }),
    createProjectRisk: build.mutation({
      query: ({ publicProjectId, body }: { publicProjectId: string; body: IProjectRiskFormValues }) => ({
        url: `projects/${publicProjectId}/risks`,
        method: "POST",
        body,
      }),
    }),
    updateProjectRisk: build.mutation({
      query: ({ publicProjectId, publicProjectRiskId, body }: { publicProjectId: string; publicProjectRiskId: string; body: IProjectRiskFormValues }) => ({
        url: `projects/${publicProjectId}/risks/${publicProjectRiskId}`,
        method: "PUT",
        body,
      }),
    }),
    deleteProjectRisk: build.mutation({
      query: ({ publicProjectId, publicProjectRiskId }) => ({
        url: `projects/${publicProjectId}/risks/${publicProjectRiskId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useGetProjectRisksQuery, useCreateProjectRiskMutation, useUpdateProjectRiskMutation, useDeleteProjectRiskMutation } = projectRisksApi;
